import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { GetPlaybackActionFromQuery } from '~/actions/playback-actions';
import { makePlaybackFromQueryIntent } from '@jet-app/music-classical/intents/query-playback/QueryPlaybackIntent';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

/**
 * Fetches additional metadata for tracks in the queue
 */
export function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/get-playback-action-from-query',
    );

    jet.onAction(
        'getPlaybackActionFromQuery',
        async (action: GetPlaybackActionFromQuery) => {
            log.info('received getPlaybackActionFromQuery:', action);
            if (action?.query) {
                log.info('fetching playback data from query');

                const playAction = await jet.dispatch(
                    makePlaybackFromQueryIntent({
                        query: action.query,
                    }),
                );

                if (playAction) {
                    jet.perform(playAction);
                }
            } else {
                log.warn('no query given to fetch playback data');
            }

            return 'performed';
        },
    );
}
